import type { AuthLogin, AuthPassword } from "~/types/schemas/autenticacao";
import type { Usuario } from "~/types/schemas/usuario";
import { API } from "~/composables/api";

class AutenticacaoAPI {
  get = async (token: string) => {
    return await API.getOne(`/auth`, { headers: { 'Authorization': token } });
  }
  
  login = async (payload: AuthLogin) => {
    return await API.post(`/auth`, { body: payload as AuthLogin });
  }

  senha = async (payload: AuthPassword) => {
    return await API.put(`/auth/senha`, { body: payload });
  }

  forgetPassword = async (payload: Partial<AuthLogin>) => {
    return await API.post(`/auth/esqueci-senha`, { body: payload });
  }
}

export const AutenticacaoApi = new AutenticacaoAPI();